import React from "react";
import UpcomingApplications from "../../../../modalcontent/UpcomingApplications";
import Modal from "../../../../elements/Modal";

const ApplicationNotOpenInfoModal = ({
  isOpen = false,
  close = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={() => close(false)}
      title={"Application Not Yet Open"}
      size="xl2"
    >
      <UpcomingApplications data={data} />
    </Modal>
  );
};

export default ApplicationNotOpenInfoModal;
